var _defs, _rect, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _rect2, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect4, _path17, _path18, _path19, _polygon2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse3, _ellipse4, _rect5, _rect6, _path27, _path28, _path29, _path30, _path31, _path32, _rect7, _path33, _path34, _polygon3, _path35, _path36, _path37, _path38, _path39, _path40, _ellipse5, _ellipse6, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle, _polygon4, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _polygon5, _polygon6, _polygon7, _polygon8, _path70, _path71, _path72, _path73, _path74, _path75, _ellipse7, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _rect8, _path105, _path106;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThief(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #adecfe;\n            }\n\n            .cls-2 {\n                fill: #573a22;\n            }\n\n            .cls-3 {\n                fill: #cd9f6f;\n            }\n\n            .cls-4 {\n                fill: #ce8d52;\n            }\n\n            .cls-5 {\n                fill: #004753;\n            }\n\n            .cls-22,\n            .cls-6 {\n                fill: #fff;\n            }\n\n            .cls-7 {\n                fill: #9aed66;\n            }\n\n            .cls-8 {\n                fill: #cfdfe5;\n            }\n\n            .cls-9 {\n                fill: #886141;\n            }\n\n            .cls-10 {\n                fill: #844e26;\n            }\n\n            .cls-11 {\n                fill: #5f003c;\n            }\n\n            .cls-12 {\n                fill: #3f012a;\n            }\n\n            .cls-13 {\n                fill: #bd9ab0;\n            }\n\n            .cls-14 {\n                fill: #f78b00;\n            }\n\n            .cls-15 {\n                fill: #facfc4;\n            }\n\n            .cls-16 {\n                fill: #efb1a5;\n            }\n\n            .cls-17 {\n                fill: #009299;\n            }\n\n            .cls-18 {\n                fill: #e3f5ff;\n            }\n\n            .cls-19 {\n                fill: #e7b3a2;\n            }\n\n            .cls-20 {\n                fill: #b78072;\n            }\n\n            .cls-21 {\n                fill: #f53f5b;\n            }\n\n            .cls-21,\n            .cls-22 {\n                fill-rule: evenodd;\n            }\n\n            .cls-23 {\n                fill: #7d3561;\n                opacity: 0.2;\n            }\n\n            .cls-24 {\n                fill: #7f5d38;\n            }\n\n            .cls-25 {\n                fill: #957247;\n            }\n\n            .cls-26 {\n                fill: #7fbf55;\n            }\n\n            .cls-27 {\n                fill: #054752;\n            }\n\n            .cls-28 {\n                opacity: 0.3;\n            }\n\n            .cls-29 {\n                fill: none;\n                stroke: #054752;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n            }\n\n            .cls-30 {\n                fill: #2ed1ff;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 292.64,
    y: 64.04,
    width: 92.47,
    height: 89.57,
    rx: 44.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.45,86.4c-.47.15-.19,6,.49,9.92a2.22,2.22,0,0,0,2.63,2l4.26-11.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349.88,90.32c.67,1.33-.29,5.34-1.15,9.24a2.22,2.22,0,0,1-2.72,1.9l-6.6-18.87Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "343.87 104.8 327.43 104.96 327.05 129.64 346.09 128.32 343.87 104.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.62,107.68c1.81,3.6,5,9.51,16.48,10.82l-1.17-12.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347,97.79c0,7.51-4.14,13.46-11.09,13.46s-11-6.16-11-13.67,4-13.52,11-13.52S347,90.29,347,97.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328,96.07c.4-1.7,4-2.4,4.8-1.22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.61,94.85c1.21-1.26,5.38-.48,5.14,1.45"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 330.2,
    cy: 98.4,
    rx: 0.81,
    ry: 0.79
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 341.82,
    cy: 98.4,
    rx: 0.81,
    ry: 0.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 323.42,
    y: 96.81,
    width: 3.15,
    height: 5.13,
    rx: 1.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 344.77,
    y: 96.81,
    width: 3.15,
    height: 5.13,
    rx: 1.57
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.84,99.87c.16,5-4.83,2.77-4.83,2.77l2.13-.88c0-.18-.27-5.53-.29-5.49A3.36,3.36,0,0,1,339.84,99.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324.8,98.33s-1.45,1.1.06,1.89"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.55,98.33l-.06,2.08s.65.12.91-.89S346.55,98.33,346.55,98.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.39,92.43l-17.23-5.76a5.05,5.05,0,0,1-3.44-5.84c.77-4.59,7.84-1.75,12,.58S345.79,88.84,346.39,92.43Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.09,104.7l3.69,0s-.22.91-1.88,1S335.09,104.7,335.09,104.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.45,123.75c4.4,4.74,17.12,5.69,23.48,1S355.88,151,355.88,151c-9.26,2.83-22.5,4.73-35.18-.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.89,120s3.92,13.27,4.41,21.33.52,12,.52,12a46.59,46.59,0,0,1-18.87-7c-10.19-6.83-13.05-13.43-13.05-13.43C302.83,129.06,326.89,120,326.89,120Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345.48,120.44s-2.93,13.27-3.42,21.32-1,11.85-1,11.85,17.07.23,27.67-10.36c0,0,8.23-6,5.29-9.83S345.48,120.44,345.48,120.44Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M378.29,129.78a.65.65,0,0,1,.91,0c3.67,3.67,6.09,5,11.36,6.31a.65.65,0,0,1,.5.63c0,10.6-3.54,17.68-12.06,21.33a.65.65,0,0,1-.51,0c-8.52-3.65-12.06-10.73-12.06-21.33a.64.64,0,0,1,.49-.63C372.2,134.77,374.61,133.45,378.29,129.78Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.44,144.44a.85.85,0,0,0-1.21,0,.85.85,0,0,0,0,1.21l3.38,3.35a.86.86,0,0,0,1.21,0l8.44-8.37a.86.86,0,0,0-1.21-1.22l-7.84,7.77Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 196.23,
    y: 64.33,
    width: 92.47,
    height: 89.57,
    rx: 44.78
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211,129.58c3.12,1.1,6.58.32,9.74-.66A80.25,80.25,0,0,0,230.78,125a7.51,7.51,0,0,0,5.2-6.61c.49-2.07,1-4.34-.08-6.22a6,6,0,0,0-4.43-2.8c-6.18-.93-13.71,3.59-18.47,7.09-2,1.47-5.25,3.66-6.1,6C205.82,125.39,208.16,128.59,211,129.58Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M208.51,105.17c-1.76.56-3.66,1.24-4.66,2.76a7.17,7.17,0,0,0-.89,3.6,6.82,6.82,0,0,0,.57,3.72c.91,1.64,2.95,2.4,4.86,2.49,5.14.25,9.56-3.2,14.35-5a46.1,46.1,0,0,0,6.3-2.36c2-1.09,3.66-3,3.66-5.15C232.71,93.78,213.1,103.68,208.51,105.17Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248.22,100.58a6.65,6.65,0,0,0-4.53,2c-1.8,2.06-1.43,5.25-.06,7.6s3.55,4.14,5.4,6.17c1.38,1.5,2.59,3.16,4.08,4.55a9.4,9.4,0,0,0,5.43,2.73c3.69.32,7.13-2.79,7.66-6.34s-1.44-7.17-4.41-9.32a29.26,29.26,0,0,1-3.31-2.38C255,102.24,253.68,100.16,248.22,100.58Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "244.27 107.07 234.06 107.83 228.68 131.37 245.42 135.31 244.27 107.07"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M233.27,111.25c.34.11-.08,9.59,11.4,10.9l-.41-14.06Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M241,153.9a47.14,47.14,0,0,1-37.49-19.63c.66-1.27,5.43-4.54,8.86-6S230,122.15,230,122.15l.49-4.74,16.14,1-.32,4.51s22.83,7.34,24.79,8.29c3.46,1.5,4.69,8.88,4.69,8.88S266.4,154.43,241,153.9Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M243.2,121.68c-4.89.94-10.28,1.42-10.28,1.42s8.32.47,9.3,1.42c-1,3.79,4.72,8.72,6.36,10,4.4,3.32,10.76.48,11.74,0-1,3.79-1.09,16.73-1.09,16.73,8.61-2.94,16.55-10.22,16.55-10.22s-2.08-8.13-3.12-8.89c-1.89-1.42-9.55-3.69-9.55-3.69Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M243.94,122.69a6,6,0,0,0,.16,2.23,5.37,5.37,0,0,0,1.13,1.75,14.91,14.91,0,0,0,6.93,5c2.8.81,6.21.1,7.85-2.24a7,7,0,0,0,.45-6.41,21,21,0,0,0-3.63-5.62,20.11,20.11,0,0,0-4.53-4.45c-2.62-2-6-6.22-7.71-2.07C243.31,113.88,244.12,119.39,243.94,122.69Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.65,88.17h.77a9.89,9.89,0,0,1,9.89,9.89v5a9.89,9.89,0,0,1-9.89,9.89h0a10.66,10.66,0,0,1-10.66-10.66V98.07A9.89,9.89,0,0,1,237.65,88.17Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M231.22,97c.64-.81,3.84-1.18,4.68,0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.26,97.51c1.27-1.2,4.9-.48,5.19,1.34"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.14,
    cy: 100.76,
    rx: 0.81,
    ry: 0.79
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.17,
    cy: 100.68,
    rx: 0.81,
    ry: 0.79
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 225.5,
    y: 98.55,
    width: 3.15,
    height: 5.13,
    rx: 1.57
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 246.85,
    y: 98.55,
    width: 3.15,
    height: 5.13,
    rx: 1.57
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M242.29,97.13c1.67,1.65,3.87,2.72,5.53,4.37,1.07,1.06,1.88,2.33,2.86,3.47a12,12,0,0,0,7.73,4.34c3,.3,6.33-1.12,7.67-3.78,1.64-3.23.07-7.2-2.38-9.9S258,91,255.4,88.45c-1.14-1.12-2.15-2.37-3.39-3.37C242.55,77.46,234.77,89.67,242.29,97.13Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2,94.32c-2.39,1.36-8.07-3.73-10.53,2.25-1,5-3.91,6.63-8.47,9.13a9.38,9.38,0,0,1-4.19,1.36,9.93,9.93,0,0,1-3.7-.81c-2.9-1.11-5.83-2.85-6.92-5.68a6.47,6.47,0,0,1,.68-5.91,6.94,6.94,0,0,1,5.32-3c1.86-.09,3.7.55,5.55.35A9.52,9.52,0,0,0,224,89.48c2.11-1.84,3.84-4.08,6-5.88s4.93-3.2,7.75-2.84C244.28,81.6,245.72,91.75,241.2,94.32Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.15,105.7l6.86,1.07a3.65,3.65,0,0,1-3.69,1.32A3.87,3.87,0,0,1,234.15,105.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M237.33,102.82l1.72-.3L239,98.64s3.19,3.28,1.95,4.78S237.33,102.82,237.33,102.82Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M278.61,129.78a.66.66,0,0,1,.92,0c3.67,3.67,6.09,5,11.36,6.31a.64.64,0,0,1,.49.63c0,10.6-3.54,17.68-12.05,21.33a.67.67,0,0,1-.52,0c-8.51-3.65-12.05-10.73-12.05-21.33a.64.64,0,0,1,.49-.63C272.52,134.77,274.94,133.45,278.61,129.78Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273.77,144.44a.87.87,0,0,0-1.22,0,.85.85,0,0,0,0,1.21l3.37,3.35a.86.86,0,0,0,1.21,0l8.44-8.37a.85.85,0,0,0,0-1.21.87.87,0,0,0-1.22,0l-7.83,7.77Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 196.6,
    y: 157.57,
    width: 92.47,
    height: 89.57,
    rx: 44.78
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M256.44,192.59c-.24-.52-.59-1-.83-1.5a14.54,14.54,0,0,1-.87-5l-2.07,4.06a1.13,1.13,0,0,0-.88.38,6.29,6.29,0,0,0-1.71,2.88,4.74,4.74,0,0,0-.16,2.42,2.65,2.65,0,0,0,1.48,1.87,3.1,3.1,0,0,0,1.76.15,4.32,4.32,0,0,0,3.48-3A3.59,3.59,0,0,0,256.44,192.59Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M233.35,197.62a2.18,2.18,0,0,0,1.67.71,4.65,4.65,0,0,0,1.82-.45,2.43,2.43,0,0,0,.91-.59c1.18-1.33.47-5.38-1.84-4.92C234.05,192.73,232,196,233.35,197.62Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "251.97 198.52 236.95 196.41 236.63 233.1 252.42 231.3 251.97 198.52"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M237.27,198.72c.35.11,1.43,13.12,14.82,14.11l-.24-15.36Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M254.37,189.65c-1.27,8.23-4.43,15.93-10,16-5.08.1-8.69-8-9.52-16.27-1.08-10.7,3.76-14,9.89-14S255.89,179.82,254.37,189.65Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M234.87,188.2s-1-.88-1.56.27c-.15.3-.17.8-.06,2.71.1,1.7,1.66,2.11,2.36,1.43C235.64,192.59,234.87,188.2,234.87,188.2Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M253.73,188.7s1.12-.94,1.68.22a12.25,12.25,0,0,1,.11,2.85c0,1.14-1.09,1.85-1.88,1.11C253.62,192.86,253.73,188.7,253.73,188.7Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M237.18,187.92c.43-1.32,3.93-1.59,4.76-.41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M247,187.64c1.26-1.19,4.57-1,5.23,0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 239.78,
    cy: 189.86,
    rx: 0.81,
    ry: 0.79
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 249.45,
    cy: 189.86,
    rx: 0.81,
    ry: 0.79
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M248.43,192.29c.13,4.5-4.52,2.88-4.52,2.88l2.13-.89c0-.17-.27-5.53-.29-5.48S248.33,188.85,248.43,192.29Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.79,176.42s-.3,12.51-5.92,11.78c-3.22-.41-3.34-4.71-.28-5,.28,0-5.05-8.5.46-10.45C238.86,171.36,240.79,176.42,240.79,176.42Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M241.21,181.44c.9,1.22,5.89,2.79,6.36-3.31-.13,4,.48,4.12,1.58,4.19,1.34.09,1.38-2.89,1.39-3.5.08,3.75,1.12,8.08,4.34,10.16,1.18-3.25.81-10.43-2.15-13.78s-7.35-3.12-9.48-2.77C239.57,173,239,178.49,241.21,181.44Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M239.94,177.37c0-.62-1.89-13.27,3.38-13.57,5.81-.34,8,11,2.92,13.26C242.36,178.82,239.94,177.37,239.94,177.37Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.22,200.2l3.69.06s-.22.91-1.87,1S243.22,200.2,243.22,200.2Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M247.16,199.45a9.76,9.76,0,0,0,3.52-.15c-1.46-.08-2-3.47-5.94-3.55-3.42-.07-4,2.89-5.66,3.33a4.22,4.22,0,0,0,1.93.42,4.35,4.35,0,0,0,3.8-2.28C244.88,197.19,245.73,199.16,247.16,199.45Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M235.32,189.26a.51.51,0,0,0-.51.17,1.17,1.17,0,0,0-.23.49.85.85,0,0,0,0,.78c.23.3.7.25,1.08.17"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M254,191.72a1,1,0,0,0,1-.8.73.73,0,0,0-.84-.79"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M236.72,211.59s4.48,18.49,9.3,18.49c3.91,0,6.36-18,6.36-18s27.89,9.48,28.87,12.32.39,3.13.39,3.13-13.33,19.86-38.11,19.76-35.37-14.56-35.37-14.56.94-6,2.14-6.91C212.21,224.3,236.72,211.59,236.72,211.59Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M278.61,222.25a.64.64,0,0,1,.92,0c3.67,3.67,6.09,5,11.36,6.31a.64.64,0,0,1,.49.63c0,10.6-3.54,17.68-12.05,21.33a.67.67,0,0,1-.52,0c-8.51-3.65-12.05-10.73-12.05-21.33a.64.64,0,0,1,.49-.63C272.52,227.24,274.94,225.92,278.61,222.25Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273.77,236.91a.87.87,0,0,0-1.22,0,.85.85,0,0,0,0,1.21l3.37,3.35a.86.86,0,0,0,1.21,0l8.44-8.37a.85.85,0,0,0,0-1.21.87.87,0,0,0-1.22,0l-7.83,7.77Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 339.3,
    cy: 202.69,
    r: 46.15
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "346.98 200.01 329.22 198.5 329.22 234.89 347.3 236.61 346.98 200.01"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M331.74,205.64c.41.14.14,11.57,15.35,13.1L347,202.16Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M350,191.3c0,10.32-4.6,19.9-12,19.9s-11.44-9.87-11.44-20.18,4.52-17.41,11.89-17.41S350,181,350,191.3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M327.72,191.09s-1.76-1.6-2.43-.32c-.17.33.09,1.72.49,3.61.26,1.24,1.05,2.09,1.89,1.33,0,0,.05-4.62.05-4.62"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M348.93,190.52s1.55-1.73,2.37-.62c.22.29.13,1.62,0,3.44-.11,1.2-.78,2.1-1.72,1.5,0,0-.62-4.32-.62-4.32"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M341.5,193.3c.18,6.18-3.83,2.75-3.83,2.75l1.75-.91c0-.21-.12-8.27-.15-8.22a9.81,9.81,0,0,1,2.23,6.38"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M328.36,185.54c5.54-1.21,10.27-6.26,11.76-9.06,2.06-3.87,3.26-10.43,3-10.44-10.94-.31-16.69,10.55-16.88,11.94-.81,6,2,7.59,2.16,7.56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.49,178.85a10.68,10.68,0,0,0,6.81,4c.48.09-2.65-8.18-4.09-9.38a8.16,8.16,0,0,0-4-1.45c-.89,1.34.18,5.29,1.32,6.87"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.14,179.18l.05,11.23s1.63.92,1.53.68,1.42-7.64,1.42-7.64Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M348.21,182.39l1.28,7.41s.83.38.83,0-1-7-1-7Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M328.36,185.54l21.52.23.42,4.43-11.1,1.14s-6.92,2.81-11.72,2l-1.29-3v-5.27Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.49,188.85a1,1,0,0,1,1.38,0,1,1,0,0,1,0,1.37,1,1,0,0,1-1.38,0,1,1,0,0,1,0-1.37"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.53,188.49a1,1,0,1,1,0,1.38,1,1,0,0,1,0-1.38"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M330.74,186.81c.46-1.19,4-2.72,5.4-1.6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M340.93,185.77c1.77-1.17,5.21-.37,5.74,1.07"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.24,192.41a.45.45,0,0,0-.73-.07,1.15,1.15,0,0,0-.21.83,2,2,0,0,0,.22.89.93.93,0,0,0,.74.5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M350.26,191.49a.45.45,0,0,1,.54.12.92.92,0,0,1,.19.56,1.32,1.32,0,0,1-.2.85.73.73,0,0,1-.77.33"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M339.52,197.69a2.87,2.87,0,0,1,3.8,0c.69.58,1.15,1.42,1.85,2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.23,197.69a2.86,2.86,0,0,0-3.79,0c-.7.58-1.16,1.42-1.85,2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "336.77 199.4 336.8 200.39 341.2 199.45 336.77 199.4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "347.7 222.12 327.63 222.12 329.05 221.52 329.1 217.43 347.07 217.43 347.01 221.86 347.7 222.12"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "359.67 226.81 316.59 226.81 327.63 222.12 347.7 222.12 359.67 226.81"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.55 231.5 308.51 231.4 312.89 228.59 316.59 226.81 359.54 226.81 366.55 231.5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372,236.18H306.78c-2.66-.89,1.73-4.78,1.73-4.78l58,.09Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M356.54,245.39h-35c-2.66-.89-8.81-4.84-8.81-4.84l53.77.15Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M365.22,240.3c-4.34.93-52.44.25-52.44.25a38.59,38.59,0,0,1-6-4.37H372S370.82,239.08,365.22,240.3Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M347.34,248.42c-4.34.94-11.74.53-11.74.53a65.65,65.65,0,0,1-14-3.43h35A47.2,47.2,0,0,1,347.34,248.42Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M371.2,222.54a3.79,3.79,0,0,1,1.29,1.29l12.77,21.28a3.77,3.77,0,0,1-3.24,5.71H356.49a3.77,3.77,0,0,1-3.77-3.77,3.81,3.81,0,0,1,.54-1.94L366,223.83A3.78,3.78,0,0,1,371.2,222.54Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.93,224.89a3.16,3.16,0,0,1,1.12,1.12l11,18.39a3.25,3.25,0,0,1-1.12,4.47,3.2,3.2,0,0,1-1.68.47H358.22a3.26,3.26,0,0,1-3.26-3.26,3.32,3.32,0,0,1,.46-1.68l11-18.39A3.25,3.25,0,0,1,370.93,224.89Zm-3.35,1.79-11,18.39a2,2,0,0,0-.28,1,2,2,0,0,0,2,1.95h22.07a1.94,1.94,0,0,0,1.68-3l-11-18.39a1.8,1.8,0,0,0-.67-.67A2,2,0,0,0,367.58,226.68Zm1.68,15.09a1.18,1.18,0,1,1-1.18,1.18A1.17,1.17,0,0,1,369.26,241.77Zm0-9.51a1.14,1.14,0,0,1,1.14,1.14.13.13,0,0,1,0,.06l-.34,6.2a.79.79,0,0,1-.78.74.78.78,0,0,1-.78-.74l-.36-6.2a1.14,1.14,0,0,1,1.06-1.2Z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 126.49,
    cy: 285.33,
    rx: 57.54,
    ry: 4.19
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M201.78,131.43c-.63.09-1.65.42-2.16.52-1.93.42-5.1,2.6-5.54,2.54a2.64,2.64,0,0,0-1.53,2.89c.39,2.51,2.79,2,3.36,1.92a65.53,65.53,0,0,0,7.14-.34,35,35,0,0,0,3.82-.7c.44-.16.45-.57,0-.56-.92,0-2.46,0-3,.07-.15,0-.14-.13-.08-.21a29.06,29.06,0,0,0,3.33-.65c.78-.25,1.72-.39,1.69-.83,0-.23-1.06-.1-2.28.1a12.51,12.51,0,0,1-2.28.2c-.14-.07-.06-.24.11-.27.62-.19,2.68-.67,3.88-1,.87-.21.86-.77.16-.7-1.14.05-3,.41-4.28.37-.13,0-.2-.19,0-.25.48-.21,3-.75,4.15-1,.82-.21.81-.81-.3-.68-1.52.06-3.22.17-4.36.3-1.39.14-2,.2-2.08,0s.78-.72,1.56-1,1.26-.94,1.11-1.38a17.22,17.22,0,0,1-2.41.65"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M158.44,146.94c1,4.4,5.78,3.44,5.78,3.44,9.14-1.81,25.87-7.92,31.46-11.37a18,18,0,0,0,2.37-1.61,2.16,2.16,0,0,0,.13-3c-.69-.76-4.26-.09-4.26-.09-40,3.62-36.15,9.53-35.48,12.63"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M176.43,74.18s-6.73,8.57-13.9,3.16c-14-10.58-22.72,1.74-18.07,12,10,22,28.47,3.55,28.47,3.55Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M120.52,178.38C118.92,202.1,136,224.32,136,224.32l11.68-1.77-2.36-47.2c0-.09-24.51-1.72-24.83,3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M136.35,218.24c-20.39,5.16-18.66,20.07-34,36.27l4.38,4.39,39.44-32.12s2.94-2.16,1.29-9.45a38,38,0,0,0-11.08.91"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M125.15,187.58c2.1,4.74,15.81,22.94,18.32,26.33,1.38,1.87,2.75,3.53,4,5a56.84,56.84,0,0,0,7.07,6.78l.52.4h0l7.17-3.29,2.62-1.19.94-.43-.08-.22,0-.13s0,0,0,0l-9.84-56.36c-.06-.07-18.57,20.8-23.13,19.36s-9.16.32-7.6,3.84"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M166.43,221.76a6,6,0,1,1-7.3-4.27,6,6,0,0,1,7.3,4.27"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M180.78,99.68c.94-.28,5.39,2.29,5.39,2.29l-4.65,3.63s4.86,5.83,2.42,11.82-8.24,15.34-8,27.11-1.57,31.94-4.87,45.6a215.1,215.1,0,0,1-8.1,25.73l-17.76-12.93Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M146.19,144.33c1.22-22,7.21-36.12,10.95-39.79,6.14-6,15.81-4,15.81-4s3.37,1.47,5.92,2.55c0,0,2.38,10.2,3.55,12.19,1.63,2.77,1.55,12.76-1,15.85-4.52,5.43-8.44,10.4-13.12,31.84,0,0,3.89,46.1,2.41,57-42.44-1.7-60.88-18.32-60.88-18.32,2.59-14.68,35.49-41.25,36.38-57.25"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M184.78,91.94,183,97.43l-2.09,6.37a3.41,3.41,0,0,1-2.32,2.39,6.69,6.69,0,0,1-4.14.16,6.55,6.55,0,0,1-5.39-5.7l4.39-13.14Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M175.81,100.14A76.08,76.08,0,0,1,173.09,113c-2.09,6.75-12,25.46-19.77,31.24-8.2,6.12-16.16,30.26-18.77,40.77-3.07,12.36-11.05,24.76-11.05,24.76S96.91,194,97.34,178.9c.22-7.76,7.87-9.29,7.87-9.29s28.4.56,37.09-18.39,10.31-15.55,10.62-32.41,16-17.22,16-17.22l0-5.34Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M173.16,97.45s2,8.81-.07,15.57-10,24-18.45,28.8-18.11,24.41-23.75,33.65-24,34.95-24,34.95-14.12-23.42-15-31.14,2.82-16,2.82-16,33,4.49,41.73-14.45,11.69-15.75,12-32.62S167,99.48,167,99.48l-1.55-3.84Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M179.37,102.23s7.64,26.23,7,28.4c-.72,2.48-1.27,4.67-7.55,4.9-3,.11,1.79-9.39,1.79-9.39Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M166.53,223.49l-6.45,49.66-6.58.43s-8.4-38.85,1.61-54.21Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M190.82,89.52a11.35,11.35,0,0,1-.4,2.21c-.74,3.41-1.75,4.8-3.59,5.67h0c-6.59,1.37-11.58-4.72-11.58-4.72l-1.79-4.85s.23-8.87,7.22-11.8c3-1.27,5.71-3,8.93-2.29,3.65.85,3.58,5.81,3.58,5.81l.43,9.14Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M190.29,88.4c-.43.36.56,1.13.56,1.13l2.76-.84s-2.41-1.07-3.32-.29"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.48,91.34c-.09.42-.2.92-.34,1.51,0,.05,0,.11,0,.17-.7-.09-2.65-.42-3-1.87,0,0,2.4.12,3.35.19"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M183,97.43l-2.09,6.37a3.41,3.41,0,0,1-2.32,2.39c-2-3.73-.08-9.87-.08-9.87Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.43,102.64s-7.31-4.44-15.58,2.56c-4.82,4.09-24.91,18.48-25.37,19.63-3.23,8,4.59,13.08,8.17,11.68,3-1.17,15.55-8.84,22.67-15.22,5.65-5.07,15.07-12.5,10.11-18.65"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M148.81,171.43c0-.67-.23-1.81-.27-2.37-.18-2.12-2.08-5.8-2-6.26a2.83,2.83,0,0,0-2.87-2c-2.73.07-2.48,2.71-2.51,3.33a68.08,68.08,0,0,0-.6,7.65,38,38,0,0,0,.22,4.18c.11.49.55.56.6.06.09-1,.3-2.62.33-3.17,0-.17.16-.13.24-.06a31.51,31.51,0,0,0,.23,3.64c.16.87.18,1.89.66,1.92.25,0,.25-1.12.21-2.45a13,13,0,0,1,.1-2.46c.09-.14.26,0,.27.16.12.69.34,2.95.5,4.27.11,1,.71,1,.73.27.1-1.23,0-3.26.19-4.62,0-.13.23-.2.27,0,.16.54.38,3.34.52,4.56.11.91.75,1,.77-.22.14-1.63.26-3.47.27-4.69,0-1.51.07-2.19.3-2.22.39,0,.66.93.84,1.79s.83,1.48,1.32,1.38a17.13,17.13,0,0,1-.36-2.67"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M129.86,125.76c-4.64,1.42-3.18,6.49-3.18,6.49,2.76,9.65,10.79,27,15,32.72a19.11,19.11,0,0,0,1.94,2.41,2.32,2.32,0,0,0,3.22-.13c.75-.81-.27-4.58-.27-4.58-7.44-42.59-13.43-37.91-16.69-36.91"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M128.51,123.4c-4.64,1.43-4.12,8.18-4.12,8.18,2.76,9.65,7,19.44,11.15,25.12l9.55-3.65c-2.41-26.7-13.32-30.64-16.58-29.65"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M171,84.06A3.51,3.51,0,1,0,175.1,81a3.63,3.63,0,0,0-4.1,3.06"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.15,271.82c.09,1.47,1.38,13.53,1.38,13.53l2,.08.66-4.9a2.15,2.15,0,0,1,2.12.71c1.91,1.87,1.79,5.23,7,5.66a30.64,30.64,0,0,0,6-.48c3.34-1,2.05-2.93.13-3.33a21.28,21.28,0,0,1-4.55-2c-2.92-1.63-5.06-6.76-6.39-9.12-.08-.14-8.35-.14-8.35-.14"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104,250.26c-1,1-9.28,9.95-9.28,9.95L96,261.78l4.13-2.72a2.11,2.11,0,0,1,.85,2.05c-.14,2.67-2.75,4.79.34,9a30.52,30.52,0,0,0,4.31,4.21c3,1.83,3.55-.39,2.59-2.1a21.19,21.19,0,0,1-1.48-4.75c-.7-3.27,1.76-8.26,2.66-10.81.05-.15-5.39-6.38-5.39-6.38"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189,83.54a.66.66,0,1,0,1.29.23.66.66,0,0,0-1.29-.23"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93,82s5.13,2.64,7.92.18a22.67,22.67,0,0,0,4.25-5Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M184.89,78.38s9.55,7,14.64,6.39S196.75,78,196.75,78s1.13-11.7-8.64-14.51c-14.78-4.25-16.45,12.56-16.45,12.56s-4.1-1.43-5.58,1.1C165.38,78.37,167.08,88.08,184.89,78.38Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M186.08,63.24s-3.26-2.21-1.18-2.71S187,63,187,63s1.51-2.86,2.54-1.82-1.82,2.52-1.82,2.52Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 205.36,
    y: 129.98,
    width: 7.72,
    height: 2.2,
    transform: "translate(-37.29 144.76) rotate(-35.25)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M197.4,134.06h11a.55.55,0,0,1,.55.55v2.49a.55.55,0,0,1-.55.55H197.75a2,2,0,0,1-2-2v0a1.62,1.62,0,0,1,1.62-1.62Z",
    transform: "translate(-41.31 141.69) rotate(-35.25)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M210.05,121.57a9.39,9.39,0,1,1,6.34,11.67,9.35,9.35,0,0,1-6.34-11.67ZM221.19,117a7.55,7.55,0,0,0-9.37,5.09,7.17,7.17,0,0,0-.28,1.51,7.54,7.54,0,0,0,14.75,2.77,7.29,7.29,0,0,0,.28-1.51A7.54,7.54,0,0,0,221.19,117Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThief);
export default __webpack_public_path__ + "static/media/Thief.d60c01a8c93ed72e2cb07abe8fa80bfc.svg";
export { ForwardRef as ReactComponent };